import { useEffect } from 'react';

const KEYCODE_SPACEBAR = 32;
const KEYCODE_ENTER = 13;

export default function useAccessibleClick(ref, handler) {
  useEffect(
    () => {
      const el = ref.current;

      const listener = (event) => {
        handler(event);
      };

      const keydownListener = (event) => {
        const { keyCode } = event;
        if (keyCode === KEYCODE_ENTER || keyCode === KEYCODE_SPACEBAR) {
          handler(event);
        }
      };

      if (el) {
        el.addEventListener('mousedown', listener);
        el.addEventListener('touchstart', listener);
        el.addEventListener('keydown', keydownListener);
      }

      return () => {
        if (el) {
          el.removeEventListener('mousedown', listener);
          el.removeEventListener('touchstart', listener);
          el.removeEventListener('keydown', keydownListener);
        }
      };
    },
    [ref, handler],
  );
}
